import React, { Suspense } from "react";
const SboPageWrapper = React.lazy(() => import("../components/SboPageWrapper"));

function SboPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <SboPageWrapper />
    </Suspense>
  );
}

export default SboPage;
